var React = require('react');

function IcSlidesDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2H3a2 2 0 0 1-2-2V5Zm2 0h14v10H3V5Zm4 12v2h14V9h-2v6a2 2 0 0 1-2 2H7Z","fill":"currentColor"}));
}

IcSlidesDownload.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IcSlidesDownload;

IcSlidesDownload.default = IcSlidesDownload;
